module.exports = __webpack_public_path__ + "static/media/contact-us-banner.3e258017.jpg";